export const isStaging = (hostName = '') => {
  const lowerHostName = hostName.toLowerCase();
  return (
    lowerHostName.search(`stg.bennie.com`) >= 0 ||
    lowerHostName.search(`stage.bennie.com`) >= 0
  );
};

export const isDev = (hostName = '') => {
  return hostName.toLowerCase().search(`devops.bennie.com`) >= 0;
};

export const isProd = (hostName = '') => {
  return (
    !isStaging(hostName) &&
    !isDev(hostName) &&
    hostName.toLowerCase().search(`bennie.com`) >= 0
  );
};

export const ZENDESK_ENVS = {
  PROD: 'PROD',
  SANDBOX: 'SANDBOX',
};

export const getZendeskEnvFromEnvironment = (envConfig) =>
  envConfig?.ENVIRONMENT === 'Production' ? ZENDESK_ENVS.PROD : ZENDESK_ENVS.SANDBOX;

/**
 * Check if user should be redirected from BCA and handle the redirect
 * @param {Object} user - The user object from UMS
 * @returns {boolean} Returns true if redirect happened, false if user can continue with app
 */
export const handleBCARedirect = user => {
  if (!user || user.bcaAccess !== false) {
    return false;
  }

  const hostName = window.location.hostname;
  let environment;

  if (isStaging(hostName)) {
    environment = 'stage';
  } else if (isProd(hostName)) {
    environment = 'pr';
  } else {
    environment = 'devops';
  }

  const profileUrl = `https://my-profile.${environment}.bennie.com`;

  window.location.href = profileUrl;
  return true;
};
